import {Component, OnInit} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {NzMessageService} from 'ng-zorro-antd/message';
import { AuthReturnUrlService } from '../services/auth-return-url.service';
import { ADMIN_MFA_ACCESS_NOTICE_KEY } from '../constants/app.constants';
import { isMobileViewport } from '../utils/mobile-viewport.utils';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [],
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.less'
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private message: NzMessageService,
    private authReturnUrl: AuthReturnUrlService,
  ) {}

  ngOnInit(): void {
    const qp = this.route.snapshot.queryParamMap;

    const token = qp.get('token');
    const error = qp.get('error'); // TOKEN_EXPIRED | INVALID_TOKEN (from BE)

    // If BE sent an error, redirect to your nice nz-result page
    if (!token && error) {
      if (error === 'ADMIN_MFA_LOCAL_LOGIN' || error === 'ADMIN_MFA_REQUIRED') {
        sessionStorage.setItem(ADMIN_MFA_ACCESS_NOTICE_KEY, error === 'ADMIN_MFA_LOCAL_LOGIN' ? 'sso' : 'desktop');
        this.router.navigate(['/login']);
        return;
      }
      const reason = error === 'TOKEN_EXPIRED' ? 'expired' : 'invalid';
      this.router.navigate(['/auth-link-error'], { queryParams: { reason } });
      return;
    }

    if (token) {
      try {
        this.authService.storeSession(token);

        this.translate.get('LOGIN.LOGIN_SUCCESS').subscribe((msg) => {
          this.message.success(msg);
        });

        // ✅ If user opens the callback link on MOBILE, send them to /mobile-desktop instead of /dashboard
        const isMobile = isMobileViewport();
        const decodedToken = this.authService.decodeToken(token);
        const userRole = decodedToken?.role || '';

        if (isMobile) {
          this.router.navigate(['/mobile-desktop']);
        } else if (this.authReturnUrl.navigateIfPresent(qp.get('returnUrl'))) {
          return;
        } else {
          this.router.navigate([userRole === 'Admin' ? '/admin/dashboard' : '/dashboard']);
        }
        return;
      } catch (error: any) {
        this.router.navigate(['/auth-link-error'], { queryParams: { reason: 'invalid' } });
        return;
      }
    }

    // No token, no error => invalid
    this.router.navigate(['/auth-link-error'], { queryParams: { reason: 'invalid' } });
  }
}
